/**
 * Redux-centric hook selecting the current project id, defaulting to number, 0
 * */

import { useSelector } from 'react-redux';

import { selectUserProjectId } from 'core/userContext';

export const useCurrentProjectId = () => {
  return useSelector(selectUserProjectId) || 0;
};
